import { Braces, Layers, Cloud, People } from "react-bootstrap-icons";
const capabilities = [
  {
    icon: Braces,
    title: "From interface to API",
    text: "Thoughtful user experiences backed by dependable services, with AI coding tools supporting everyday development.",
    skills: [
      "React",
      "Angular",
      "TypeScript",
      "Kotlin",
      "Python",
      "Node.js",
      "Java",
      "HTML & Sass",
      "Claude Code",
      "Codex",
      "Cursor",
    ],
  },
  {
    icon: Layers,
    title: "Systems & AI agents",
    text: "Scalable data systems, AI agents, and reusable agent skills for practical workflows.",
    skills: [
      "AI agents",
      "Agent skills",
      "Microservices",
      "REST APIs",
      "Event-driven systems",
      "SQL",
      "MongoDB",
      "Redis",
      "OLAP",
    ],
  },
  {
    icon: Cloud,
    title: "Built for the cloud",
    text: "From development environments to production delivery.",
    skills: [
      "AWS",
      "Docker",
      "Kubernetes",
      "Jenkins",
      "Git",
      "Multi-tenant platforms",
    ],
  },
  {
    icon: People,
    title: "Better, together",
    text: "Helping engineers grow and teams turn ambitious ideas into working software.",
    skills: [
      "Technical direction",
      "Mentoring",
      "Team building",
      "Cross-functional delivery",
    ],
  },
];
export const Skills = () => (
  <section
    className="expertise-section"
    id="skills"
    aria-labelledby="expertise-title"
  >
    <div className="page-shell">
      <div className="section-heading">
        <div>
          <p className="eyebrow">03 / How I work</p>
          <h2 id="expertise-title">
            Depth in the details.
            <br />
            <em>Perspective on the whole.</em>
          </h2>
        </div>
        <p>
          Hands-on engineering, thoughtful architecture, and the people skills
          to bring it all together.
        </p>
      </div>
      <div className="capability-grid">
        {capabilities.map(({ icon: Icon, title, text, skills }) => (
          <article className="capability" key={title}>
            <Icon size={27} aria-hidden="true" />
            <h3>{title}</h3>
            <p>{text}</p>
            <ul className="tag-list">
              {skills.map((skill) => (
                <li key={skill}>{skill}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);
